import React, {Fragment} from "react";
import {Header, Footer} from "apps/DRAW_PREDICTOR/components";

export const HOCLayout: React.FC = ({children}) => (
	<Fragment>
		<Header />
		<main>{children}</main>
		<Footer />
	</Fragment>
);
